import { render, staticRenderFns } from "./CustomerHeader.vue?vue&type=template&id=301f52b2&"
import script from "./CustomerHeader.vue?vue&type=script&lang=js&"
export * from "./CustomerHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports